export const timeFormats = Object.freeze({
  DATE_MONTH: "DD MMM YYYY",
  DATE_MONTH_TIME: "DD MMM YYYY hh:mm:ss A",
});

export const InputKeys = {
  ENTER_KEY: 'Enter',
};

export const NOTIFICATION_POLLING_INTERVAL = 60000;//1 minute

export const NOTIFICATION_DISMISS_TIME = 86400; //24 hours

export const notificationTypes = {
  ALERT: "alert",
  NOTIFICATION: "notification",
  WARNING: "warning",
};

export const BRONTE_BETA_STORAGE_KEY = "homepageShowBetaMessagev2";

export const IES_V2_AUTH = 'IES_V2_AUTH';
export const IES_V2_AUTH_VALUE = 'IES_V2_AUTH_VALUE';

export const PUBLICATION_STATUS = Object.freeze({
  IN_REVIEW: 'IN_REVIEW',
  PUBLISHED_LIVE: 'PUBLISHED_LIVE',
});
